export default {
  BLIP_1: {
    title: 'Mensagens Recebidas',
    description: 'Total de mensagens recebidas no periodo (dos contatos para o bot).',
  },
  BLIP_2: {
    title: 'Mensagens Enviadas',
    description: 'Total de mensagens enviadas no periodo (do bot para os contatos).',
  },
  BLIP_3: {
    title: 'Mensagens Ativas',
    description: 'Total de mensagens ativas enviadas no período (24 horas após a última interação do contato).',
  },
  BLIP_4: {
    title: 'Total de Contatos Únicos no Período',
    description: 'Total de contatos únicos no período, que receberam ou enviaram mensagem para o bot.',
  },
  BLIP_5: {
    title: 'Contatos com Interação no Período',
    description: 'Total de contatos únicos no período, que enviaram mensagem para o bot.',
  },
  BLIP_6: {
    title: 'Contatos Únicos por Intervalo',
    description: 'Contatos únicos por intervalo (dia ou mês), que receberam ou enviaram mensagem para o bot.',
  },
  BLIP_7: {
    title: 'Contatos com Interação por Intervalo',
    description: 'Contatos únicos por intervalo (dia ou mês), que enviaram mensagem para o bot.',
  },
  BLIP_8: {
    title: 'Mensagens Enviadas por Intervalo',
    description: 'Mensagens enviadas por intervalo (dia ou mês), do bot para os contatos.',
  },
  BLIP_9: {
    title: 'Mensagens Recebidas por Intervalo',
    description: 'Mensagens recebidas por intervalo (dia ou mês), do bot para os contatos.',
  },
  BLIP_10: {
    title: 'Mensagens Ativas por Intervalo',
    description: 'Mensagens ativas enviadas por intervalo (dia ou mês), 24 horas após a última interação do contato.',
  },
  BLIP_11: {
    title: 'Volume de mensagens no período',
    description: 'Gráfico de linha com o total de mensagens enviadas e recebidas, dentro do período selecionado.',
  },
  BLIP_12: {
    title: 'Contatos que não responderam',
    description: 'Total de contatos únicos que não responderam a nenhuma mensagem enviada pelo chatbot e não iniciaram nenhuma conversa, no período selecionado.',
  },
  BLIP_13: {
    title: 'Contatos com interação x Contatos que não responderam',
    description: 'Gráfico de linha com o total de contatos únicos que não responderam e contatos únicos que interagiram com o chatbot, dentro do período selecionado.',
  },
  BLIP_14: {
    title: 'Taxa de rejeição',
    description: 'Cálculo da porcentagem do total de contatos únicos que não responderam ao chatbot dividido pelo número total de contatos únicos no período selecionado. Calculado através da seguinte fórmula: Total de Contatos que não responderam / Total de contatos únicos * 100%.',
  },
  BLIP_15: {
    title: 'Mensagens ativas por canal',
    description: 'Tabela com o total de mensagens ativas enviadas por canal no período de tempo selecionado. São consideradas mensagens ativas as mensagens que foram enviadas pelo chatbot após 24 horas do recebimento da última mensagem enviada pelo contato.',
  },
  BLIP_16: {
    title: 'Taxa de interação',
    description: 'Cálculo da porcentagem do total de contatos únicos que responderam e interagiram com o chatbot sobre o número total de contatos únicos no período selecionado. Calculado através da seguinte fórmula: Total de Contatos com Interação / Total de contatos únicos * 100%.',
  },
  BLIP_17: {
    title: 'Total de mensagens trafegadas',
    description: 'Total de mensagens enviadas e recebidas pelo chatbot no fluxo conversacional. Inclui, também, mensagens trafegadas no Blip Desk, entre os contatos e atendentes.',
  },
  BLIP_18: {
    title: 'Total de Eventos Personalizados',
    description: 'Número total de Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
  },
  BLIP_19: {
    title: 'Distribuição de Eventos Personalizados',
    description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
  },
  BLIP_20: {
    title: 'Distribuição de Eventos Personalizados (Percentual)',
    description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, dentro do período selecionado.',
  },
  BLIP_21: {
    title: 'Eventos Personalizados no Tempo',
    description: 'Divisão dos Eventos Personalizados de acordo com as opções aplicadas no filtro, ao longo de um período de tempo. Atenção: Apenas as 50 ações mais numerosas são mostradas.',
  },
  BLIP_22: {
    title: 'Minhas Campanhas',
    description: 'Total de campanhas ativas enviadas e agendadas através dos contatos inteligentes no período selecionado.',
  },
  BLIP_23: {
    title: 'Tickets abertos',
    description: 'Total de tickets que foram abertos no período selecionado.',
  },
  BLIP_24: {
    title: 'Tickets perdidos',
    description: 'Total de atendimentos que foram encerrados pelo cliente enquanto ele ainda estava na fila de atendimento e ainda não havia sido atribuído a um atendente.',
  },
  BLIP_25: {
    title: 'Tickets abandonados',
    description: 'Total de atendimentos que foram encerrados pelo cliente e depois foram distribuídos ou puxados por um atendente.',
  },
  BLIP_26: {
    title: 'Tickets atendidos',
    description: 'Total de atendimentos que foram finalizados ou transferidos para outra fila ou atendente.',
  },
  BLIP_27: {
    title: 'Tickets fechados',
    description: 'Total da soma dos atendimentos perdidos, abandonados e atendidos.',
  },
  BLIP_28: {
    title: 'Funil de conversão',
    description: 'Apresenta métricas de desempenho por etapa dos envios de mensagens ativas realizados pelos contatos inteligentes selecionados.',
  },
  BLIP_29: {
    title: 'Tempo máximo na fila',
    description: 'Apresenta o maior tempo que um cliente esperou na fila até ser distribuído ou ser puxado por um atendente. Para chegar nesse número são considerados apenas os tickets fechados no período selecionado, que já foram removidos da tela do atendente.',
  },
  BLIP_30: {
    title: 'Tempo máximo até 1ª resposta',
    description: 'Apresenta o máximo de tempo que um cliente levou para receber o primeiro contato do atendente depois de ter sido distribuído ou puxado pelo atendente. Para chegar nesse número são considerados apenas os tickets fechados no período selecionado, que já foram removidos da tela do atendente.',
  },
  BLIP_31: {
    title: 'Tempo médio na fila',
    description: 'Tempo médio que os clientes estão aguardando na fila até serem atribuídos a um atendente. O cálculo desta métrica considera os tempos apenas dos tickets fechados no período selecionado, que já foram removidos da tela do atendente.',
  },
  BLIP_32: {
    title: 'Tempo médio até 1ª resposta',
    description: 'Tempo médio que os atendentes estão levando para enviar a primeira mensagem para o cliente depois que eles são atribuídos ao atendente. O cálculo desta métrica considera os tempos apenas dos tickets fechados no período selecionado, que receberam uma primeira resposta do atendente e que já foram removidos da tela do atendente.',
  },
  BLIP_33: {
    title: 'Tempo médio de espera',
    description: 'Tempo médio que um cliente demora para receber o primeiro atendimento, é a diferença entre o momento que o atendimento é distribuído para uma fila de atendimento até o momento que o atendente envia a primeira resposta.',
  },
  BLIP_34: {
    title: 'Tempo médio de resposta',
    description: 'Tempo médio que os atendentes estão levando para responder as mensagens do cliente. O cálculo desta métrica considera apenas tickets que tiveram pelo menos uma interação completa entre cliente e atendente, ou seja, tickets em que o cliente mandou mensagem e o atendente respondeu, e que foram fechados no período selecionado, e já foram removidos da tela do atendente.',
  },
  BLIP_35: {
    title: 'Tempo médio de atendimento',
    description: 'O cálculo desta métrica considera apenas os tempos dos tickets fechados no período, que já foram removidos da tela do atendente.',
  },
  BLIP_36: {
    title: 'Volume de tickets por dia',
    description: 'Quantidade de tickets abertos e fechados por dia dentro do período de tempo selecionado.',
  },
  BLIP_37: {
    title: 'Disponibilidade de atendentes',
    description: 'Relatório com o tempo que cada atendente passou em cada status para trazer uma visão de disponibilidade dos mesmos no período de tempo selecionado.',
  },
  BLIP_38: {
    title: 'Relatórios de atendimentos - Atendentes',
    description: 'Relatório de tickets finalizados e suas respectivas métricas por Atendente dentro do período de tempo selecionado.',
  },
  BLIP_39: {
    title: 'Relatórios de atendimentos - Filas',
    description: 'Relatório de tickets finalizados e suas respectivas métricas por Fila dentro do período de tempo selecionado.',
  },
  BLIP_40: {
    title: 'Relatórios de atendimentos - Tags',
    description: 'Relatório de tickets finalizados e suas respectivas métricas por Tag dentro do período de tempo selecionado.',
  },
  BLIP_41: {
    title: 'Tickets por atendente',
    description: 'Média de tickets que estão com os atendentes no momento..',
  },
  BLIP_42: {
    title: 'Volume de tickets na fila',
    description: 'Quantidade de tickets nas filas de atendimento, será considerado o total de tickets que ainda não foram atribuídos de todas as filas deste bot, ou das filas que estiverem filtradas.',
  },
  BLIP_43: {
    title: 'Tickets em atendimento',
    description: 'Quantidade total de tickets que estão em atendimento no momento, ou seja, já foram distribuídos ou puxados pelo atendente, e já receberam a primeira resposta do atendente, mas ainda não foram encerrados.',
  },
  BLIP_44: {
    title: 'Atendentes online',
    description: 'Quantidade de Atendentes que estão ativos e aptos a receber novos atendimentos.',
  },
  BLIP_45: {
    title: 'Atendentes em pausa',
    description: 'Quantidade de Atendentes que estão em alguma pausa, seja a pausa padrão ou alguma pausa personalizada, como almoço, banheiro, etc e por isso não recebem novos atendimentos.',
  },
  BLIP_46: {
    title: 'Atendentes offline',
    description: 'Quantidade de Atendentes que estão inativos e não podem receber novos atendimentos.',
  },
  BLIP_47: {
    title: 'Gestão de atendimento - Atribuído/Em Atendimento',
    description: 'Listagem de atendimentos que já foram atribuídos a um atendente e os atendimentos que estão em andamento.',
  },
  BLIP_48: {
    title: 'Gestão de atendimento - Aguardando atendimento',
    description: 'Listagem de atendimentos que estão na fila de atendimento e ainda não foram atribuídos a um atendente.',
  },
  BLIP_49: {
    title: 'Gestão de atendimento - Atendentes',
    description: 'Listagem de atendimentos que já foram atribuídos separados por atendente.',
  },
  BLIP_50: {
    title: 'Gestão de atendimento - Filas',
    description: 'Listagem de atendimentos separados por fila.',
  },
  BLIP_51: {
    title: 'Gestão de atendimento - Tags',
    description: 'Listagem de atendimentos que já foram finalizados separados por tags.',
  },
};
